<button
    fxLayout="row"
    fxLayoutAlign="center center"
    class="w-100-p"
    mat-flat-button
    [color]="color ? color : 'accent'"
    (click)="onClickButton($event)"
    [disabled]="disabled"
    [loading]="isLoading"
    #btnFocus
    [autofocus]="autofocus ? btnFocus.focus() : null"
    [class.icon-button]="!label"
    [class.icon-right]="iconRight && (icon || svgIcon)"
    [class.participant-view-btn]="participantViewButton"
    [class.!bg-primary-300]="isSecondaryButton"
    [class.flat-btn--brand-green]="brandGreenButton"
    [class.w-full]="fullWidth"
    [class.force-trailing-icon-on-right]="forceTrailingIconOnRight"
>
    <mat-icon class="button-icon mr-8" *ngIf="icon">{{ icon }}</mat-icon>
    <mat-icon class="button-icon mr-8" *ngIf="svgIcon" [svgIcon]="svgIcon"></mat-icon>

    <span class="text-sm button-label">{{ label | translate }}<span *ngIf="showThreeDots">...</span></span>
    <mat-icon class="ml-8 trailing-arrow-icon" *ngIf="showArrowDown">keyboard_arrow_down</mat-icon>
    <span class="text-sm" *ngIf="counter"> &nbsp;({{ counter }})</span>
</button>
